import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class CouldNotConvertQuoteException extends QuoteException {

}